export class FormsServices {
    constructor(apiService, formsFactory, queryParamsFactory) {
        this.apiService = apiService;
        this.formsFactory = formsFactory;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(id) {
        const response = await this.apiService.get('form/' + id);
        if (!response.ok) {
            throw new Error(`Error al obtener el formulario.`);
        }
        const content = await response.json();
        return this.formsFactory.createFormFromState(content);
    }
    async queryForms(query) {
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`forms?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener formularios.`);
        }
        const { results } = await response.json();
        return results.map(formState => this.formsFactory.createFormFromState(formState));
    }
    async findForms(offset = 0, limit = 20) {
        const response = await this.apiService.get('forms/' + offset + '/' + limit);
        if (!response.ok) {
            throw new Error(`Error al obtener formularios.`);
        }
        const content = await response.json();
        return content.map(formState => this.formsFactory.createFormFromState(formState));
    }
    async saveForm(form) {
        const response = await this.apiService.post('form', form);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar el formulario.');
        }
    }
    async duplicateForm(formId) {
        const response = await this.apiService.get(`form/duplicate/${formId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener un duplicado del formulario.');
        }
        const content = await response.json();
        return content.formId;
    }
    async enableForm(formId) {
        const response = await this.apiService.get(`form/${formId}/enable`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al activar el formulario.');
        }
    }
    async disableForm(formId) {
        const response = await this.apiService.get(`form/${formId}/disable`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al desactivar el formulario.');
        }
    }
    async removeForm(formId) {
        const response = await this.apiService.delete(`form/${formId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar el formulario.');
        }
    }
    async passToProduction(formId) {
        const response = await this.apiService.get(`form/${formId}/production`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al pasar el formulario ha producción.');
        }
    }
    async passToDeveloping(formId) {
        const response = await this.apiService.get(`form/${formId}/developing`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al pasar el formulario ha desarrollo.');
        }
    }
    async saveFormStatus(formSave) {
        try {
            const response = await this.apiService.post('form_status', { formSave });
            if (!response.ok) {
                return false;
            }
            return;
        }
        catch (err) {
            console.error(err);
            return false;
        }
    }
}
